import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { TermsAcceptanceModal } from './TermsAcceptanceModal.js';
import type { ReactNode } from 'react';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, authLoading } = useAuth();

  if (authLoading) {
    return (
      <div className="dashboard">
        <div className="container" style={{ textAlign: 'center', padding: '4rem 0' }}>
          <span className="spinner" /> Loading...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/connect" replace />;
  }

  return (
    <>
      <TermsAcceptanceModal />
      {children}
    </>
  );
}
